import { AppState } from 'common/models/appState.model';

const initialAppState: AppState = {
    messageModal: undefined,
    showLoader: false,
    isSessionRenewalVisible: false
};

export default initialAppState;
